export * from 'server/models/LloydServiceVessel';


// WEBPACK FOOTER //
// ./data/models/LloydServiceVessel.ts